import React, { forwardRef } from 'react';

export default function Radio ({ name, radioBtnName,checked,onChange,value }) {
    return (
        
        <label className="radio"><input type="radio" name={name} checked={checked} onChange={onChange} value={value}/><span></span>{radioBtnName}</label>
    )
}